<template>
  <div class="row">
    <BaseTextInput
      v-bind="email"
      v-bind:disabled="readonly"
      v-bind:value="value.email"
    />
    <BaseTextInput
      v-bind="tipo"
      v-bind:disabled="readonly"
      v-bind:value="value.tipoEmail"
    />
  </div>
</template>

<script>
export default {
  name: "BaseEmail",
  inheritAttrs: false,
  props: {
    email: {
      type: Object,
      required: true
    },
    tipo: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      readonly: true
    };
  }
};
</script>

<style scoped>
.row {
  margin-bottom: 0;
}
</style>
